<template>
  <div id="center-subscription">
    <div class="flex">
      <div
        class="sticky left-60 z-40 py-3 px-6 flex items-center justify-between gap-4"
        :style="{ width: 'calc(100vw - 15rem - 0.5rem)' }"
      >
        <div class="flex items-center gap-4">
          <BlTextTitle3 text="Subscription information" />
          <BlBubbleCount :count="totalSubscriptions || 0" />
        </div>

        <div class="flex items-center gap-4">
          <BlInputButton
            icon="plus"
            label="New subscription"
            @clicked="newOpened = true"
          />
        </div>
      </div>
    </div>

    <NewSubscriptionModal
      v-if="newOpened"
      @after-commit="fetchSubscriptions"
      @close-modal="newOpened = false"
    />

    <div v-if="pageLoading" class="h-128 grid place-items-center">
      <div class="blum-loader"></div>
    </div>
    <div
      v-else-if="!subscriptions.length"
      class="h-128 flex flex-col items-center justify-center"
    >
      <BlTextBody1
        class="text-center"
        text="No active subscriptions have been created yet. Start by adding a new subscription to get started."
      />
    </div>
    <div v-else class="mb-8">
      <div
        id="center-subscription-header"
        class="sticky top-10 z-20 flex items-center flex-grow bg-slate-300 rounded-t"
      >
        <div class="sticky left-60 z-10 pl-6 flex bg-slate-100">
          <BlTooltip
            class="w-60 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 rounded-tl border-l"
          >
            <BlTextSubtitle3 text="Subscription name" class="truncate" />
          </BlTooltip>
        </div>
        <BlTooltip
          class="w-35 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
        >
          <BlTextSubtitle3 text="Start date" class="truncate" />
        </BlTooltip>
        <BlTooltip
          class="w-35 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
        >
          <BlTextSubtitle3 text="Expiry date" class="truncate" />
        </BlTooltip>
        <BlTooltip
          class="w-35 h-12 pl-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
        >
          <BlTextSubtitle3 text="Number of seats" class="truncate" />
        </BlTooltip>
        <BlTooltip
          class="w-60 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
        >
          <BlTextSubtitle3 text="Total amount due" class="truncate" />
        </BlTooltip>
        <BlTooltip
          class="w-35 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
        >
          <BlTextSubtitle3 text="Status" class="truncate" />
        </BlTooltip>
        <!-- <BlTooltip
          class="w-44 h-12 pl-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 justify-end gap-2"
        >
          <BlTextSubtitle3 text="" />
        </BlTooltip> -->
        <div class="sticky right-0 z-10 pr-6 flex bg-slate-100 flex-grow">
          <div
            class="w-56 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 rounded-tr border-r flex-grow"
          >
            <BlTextSubtitle3 text="" />
          </div>
        </div>
      </div>

      <SubscriptionItem
        v-for="(subscription, idx) in subscriptions"
        :key="subscription.id"
        :subscription="subscription"
        :centerId="center.id"
        :isLast="idx + 1 === subscriptions.length"
      />
    </div>

    <div v-if="totalSubscriptions > 25" class="flex mb-36">
      <BlInputPagination
        class="sticky left-66"
        :style="{ width: 'calc(100vw - 15rem - 3rem - 0.5rem)' }"
        :page="page"
        :perPage="perPage"
        :total="totalSubscriptions"
        @changed="changePage"
        @changed-per-page="changePerPage"
      />
    </div>
    <div v-else class="mb-46"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SubscriptionItem from "./subscription/Item.vue";
import NewSubscriptionModal from "./subscription/NewSubscriptionModal.vue";

import BlTextTitle3 from "../../BlTextTitle3.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlBubbleCount from "../../BlBubbleCount.vue";
import BlTooltip from "../../BlTooltip.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlInputPagination from "../../BlInputPagination.vue";

export default {
  name: "CenterSubscription",
  components: {
    SubscriptionItem,
    NewSubscriptionModal,
    //
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody1,
    BlTextBody2,
    BlBubbleCount,
    BlTooltip,
    BlIcon,
    BlInputButton,
    BlInputPagination
  },
  data() {
    return {
      pageLoading: true,
      newOpened: false,
      //
      page: 1,
      perPage: 25
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "center",
      "subscriptions",
      "totalSubscriptions"
    ]),
    getParams() {
      let params = `?page=${this.page}&per_page=${this.perPage}`;
      return params;
    }
  },
  watch: {},
  async mounted() {
    this.pageLoading = true;

    const searchParams = this.$route.query;

    if (searchParams["page"]) {
      this.page = Number(searchParams["page"]);
    }
    if (searchParams["per_page"]) {
      this.perPage = Number(searchParams["per_page"]);
    }

    this.fetchSubscriptions();
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {
    ...mapActions(["getSubscriptions"]),
    fetchSubscriptions() {
      const centerId = Number(this.$route.params.id);
      const params = {
        center_id: centerId,
        params: this.getParams
      };

      this.pageLoading = true;
      this.getSubscriptions(params).then(() => {
        this.pageLoading = false;
      });

      // sync url path for page
      const incomingPath = `/super-admin/center/${centerId}/subscription${this.getParams}`;
      if (this.$route.fullPath !== incomingPath) {
        return this.$router.push(incomingPath);
      }
    },
    //
    changePage(page) {
      if (page === this.page) return;
      this.page = page;
      this.fetchSubscriptions();
    },
    changePerPage(perPage) {
      if (perPage === this.perPage) return;
      this.page = 1;
      this.perPage = perPage;
      this.fetchSubscriptions();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/center/CenterSubscription.vue